const ProgramStatus = Object.freeze({
  ACTIVE: 1,
  DISABLED: 0
});

export {ProgramStatus}




// WEBPACK FOOTER //
// ./src/enums/programStatus.js